import { TextField } from "@mui/material"
import { useMask } from "@react-input/mask"
import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"

import StyledHelperText from "@/components/StyledHelperText"

import { PassHolderFormData } from "../../schema"

const BirthDateField = () => {
  const { t } = useTranslation()
  const { control, trigger } = useFormContext<PassHolderFormData>()

  const birthDateMaskRef = useMask({
    mask: "________",
    replacement: { _: /[0-9]/ },
  })

  return (
    <Controller
      name="birthDate"
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          inputRef={birthDateMaskRef}
          {...field}
          placeholder={t("passHolderDetails.form.birthDateFormat")}
          label={t("passHolderDetails.form.birthDate")}
          error={!!error}
          onChange={(e) => {
            field.onChange(e)
            if (e.target.value.length === 6 || e.target.value.length === 8) {
              trigger(["birthDate"])
            }
          }}
          helperText={
            error?.message ? (
              <StyledHelperText helperText={error.message} severity="error" />
            ) : undefined
          }
        />
      )}
    />
  )
}

export default BirthDateField
